import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { UserAvatarWithName } from "@/components/common/UserAvatarWithName";
import { Badge } from "@/components/ui/badge";
import type { SelectedRecipientsProps } from "@/features/chat/types";

export const SelectedRecipients = ({
  recipients,
  onRemove,
  showTitle = true,
}: SelectedRecipientsProps) => {
  const { t } = useTranslation();

  return (
    <div>
      {showTitle && recipients.length > 0 && (
        <p className="mb-1 text-xs font-medium">
          {t("chat.selectedRecipientsLabel")}
        </p>
      )}
      <div className="flex max-h-24 min-h-10 flex-wrap gap-2 overflow-y-auto rounded-md bg-muted/30 p-2">
        {recipients.length > 0
          ? recipients.map((recipient) => (
              <Badge
                key={recipient.guid}
                variant="secondary"
                className="flex items-center gap-1 bg-white px-2 py-1"
              >
                <UserAvatarWithName user={recipient} size="sm" />
                <X
                  size={14}
                  className="cursor-pointer hover:text-destructive"
                  onClick={() => onRemove(recipient)}
                />
              </Badge>
            ))
          : null}
      </div>
    </div>
  );
};
